module.exports = __webpack_public_path__ + "static/media/flag_qa.7a417f31.png";